/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, ReactElement } from 'react';
import { connect } from 'react-redux';
import uuid from 'uuid';
import type { HostContext, Logger } from '../../../@types';
import SearchUtils from '../../../utils/SearchUtils';
import { setFilteredSearchDropdownItems } from '../../../actions/searchActions';
import SearchDropdownAutoCompleteItem from './SearchDropdownAutoCompleteItem';
import SearchAnalytics from '../../../analytics/SearchAnalytics';
type Props = {
	searchHostContext: HostContext;
	logger: Logger;
	onSubmit: (...args: Array<any>) => any;
	searchQuery: string;
	searchAutoCompleteTextSuggestions: Array<{ name: string; source: string }>;
	hostShowSearchDropdown: boolean;
};
/*
 * SearchDropdownAutoComplete for Search.
 */

class SearchDropdownAutoComplete extends Component<Props> {
	/**
	 * Returns the render for the Search Auto-Complete Items
	 * @returns <element>
	 */
	renderSearchAutoCompleteItems() {
		let elements: ReactElement[] = [];
		const searchAutoCompleteTextSuggestions: Array<{ name: string; source: string }> = this.props.searchQuery
			? [...this.props.searchAutoCompleteTextSuggestions]
			: [];
		// Show the Search Dropdown with the list of search auto suggestion items
		if (
			searchAutoCompleteTextSuggestions &&
			Array.isArray(searchAutoCompleteTextSuggestions) &&
			searchAutoCompleteTextSuggestions.length > 0
		) {
			elements = searchAutoCompleteTextSuggestions.map((item, index) => (
				<SearchDropdownAutoCompleteItem
					key={uuid.v4()}
					searchHostContext={this.props.searchHostContext}
					item={item}
					index={index}
					searchQuery={this.props.searchQuery}
					hostShowSearchDropdown={this.props.hostShowSearchDropdown}
					onSubmit={this.props.onSubmit}
					logger={this.props.logger}
				/>
			));
		}

		if (searchAutoCompleteTextSuggestions?.length > 0) {
			const analytics = new SearchAnalytics(this.props.searchHostContext);
			analytics.postSuggestionRender(searchAutoCompleteTextSuggestions, 'suggestion', 'autocomplete');
		}

		SearchAnalytics.dropDownData.searchAutoComplete = searchAutoCompleteTextSuggestions;
		return elements.length ? elements : null;
	}

	render() {
		return this.renderSearchAutoCompleteItems();
	}
}

function mapStateToProps({ search }) {
	return {
		searchAutoCompleteTextSuggestions: search.searchAutoCompleteTextSuggestions,
	};
}

export default connect(mapStateToProps, {
	setFilteredSearchDropdownItems,
})(SearchDropdownAutoComplete);
